<template>
<section>
  <div class="container">
      <div class="row">
          <div class="col-md-7">
            <div class="employee1 mt-5 mb-3">
                <h5 class="text-info">Employees Form</h5>
            </div>
            <div class="employee1 ">
              <employee-form @add:employee="addEmployee"/>
            </div>
          </div>
           <div class="col-md-5">
            <div class="employee1 mt-5 mb-3">
                <h5 class="text-info">Employees Table</h5>
            </div>
            <div class="employee1">
              <employee-table :employees="employees" @delete:employee="deleteEmployee"/>
            </div>
          </div>
      </div>
  </div>
</section>
</template>

<script>
import EmployeeTable from './components/EmployeeTable.vue';
import EmployeeForm from  './components/EmployeeForm.vue';
import './assets/css/responsive.css';
export default {
  name: 'App',
  components: {
     EmployeeTable,
     EmployeeForm
  },
  data(){
    return{
        employees:[
          {
            id:1,
            name:'Sathish Mathew',
            email:'sathishmathew@gmail.com'
          },
          {
            id:2,
            name:'Guru Prasath',
            email:'sathishmathew@gmail.com'
          },
          {
            id:3,
            name:'Mathew Sathish',
            email:'sathishmathew@gmail.com'
          }
        ]
    }
  },
  methods:{
    addEmployee(employee){
          const lastId =this.employees.length>0?this.employees[this.employees.length-1].id:0;
          const id =lastId+1;
          const newEmployee = {...employee,id}
          this.employees =[...this.employees,newEmployee];
    },
    deleteEmployee(id){
      this.employees =this.employees.filter((employee)=>{
                return employee.id !=id;
      })
    }
  }

}
</script>

<style>
.employee1
{
  display:flex;
  justify-content: center;
}
.text-info
{
  font-weight:500;
}
</style>
